import React from 'react'
import QRCode from 'react-qr-code'

import './QrChannelPage.css'

import Page from '../../../components/layouts/Page'
import useQrChannelConnection from '../hooks/useQrChannelConnection'
import { getQrChannelConfig } from '../qrChannelConfig'

const fallbackConfig = {
   title: '',
   description: '',
   instructions: [],
   selectQrLoading: () => false,
   selectQrValue: () => '',
   selectSourceId: () => '',
   fetchQrThunk: () => () => Promise.resolve(),
   startScanThunk: () => () => Promise.resolve(false),
   clearAction: () => ({ type: 'noop' })
}

const QrChannelPage = ({ channelType }) => {
   const config = getQrChannelConfig(channelType) || fallbackConfig

   const { title, description, instructions } = config
   const { qrLoading, qrValue } = useQrChannelConnection(config)

    if (!getQrChannelConfig(channelType)) return null

   return (
      <Page
         title={title}
         returnBtn
      >
         <div className='qr-channel-page-body'>
            <p className='qr-channel-page-description'>{description}</p>
            <ul className='qr-channel-page-instructions-list'>
               {instructions.map((text, i) => (
                  <li key={i} className='qr-channel-page-instructions__list-item'>
                     <span>{`${i + 1}.`}</span>
                     {text}
                  </li>
               ))}
            </ul>
            <div className='qr-channel-page-qr-code'>
               {qrLoading
                  ? <div className='qr-loader'></div>
                  : (
                     <QRCode
                        style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
                        value={qrValue}
                     />
                  )}
            </div>
         </div>
      </Page>
   )
}

export default QrChannelPage
